import { useEffect } from 'react';
import { useContent, useLoading } from '../../hooks/customHooks';
import './NotFoundPage.css';
import Footer from '../../components/Footer';
import PageSlug from '../../components/PageSlug';
import Brand from '../../components/Brand';
import ReturnToOriginButton from '../../components/ReturnToOriginButton';

export default function NotFoundPage() {
    const { setLoading } = useLoading();
    const { content } = useContent();

    const g = content?.global_settings?.images;

    useEffect(() => {
        setLoading(false);
    }, []);

    return (
        <div className={`${g?.bg ? 'has-bg' : ''} page-wrapper signUpPage`}>
            {g?.bg && (
                <div
                    className={`${g?.bg ? 'with-bg' : ''}`}
                    style={{ backgroundImage: g?.bg && `url(${g?.bg})` }}
                ></div>
            )}
            {g?.header && <Brand image={g?.header} />}

            <main>
                <section className={`main-content ${g?.bg ? 'transparent-container' : ''}`}>
                    <PageSlug subtitle={'Oops this page doesn’t exist'} />

                    <ReturnToOriginButton />

                    {g?.body && <img className="mb-n mt-n body-img" alt="" src={g?.body} />}
                </section>

                {<Footer className={`${g?.bg ? 'transparent-container' : ''}`} />}
            </main>
        </div>
    );
}
